module.exports = __webpack_public_path__ + "fonts/icon_set_2.585336b8.eot";